import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import { uiActions } from '../slices/uiSlice';
import type { RootState } from '../store';

import { eventsService } from './_deps';

export const fetchEventsDate = createAsyncThunk<void, { date: string }, { state: RootState }>(
  'events/fetchDate',
  async ({ date }, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      const res = await eventsService.listEventsDate({ date });
      dispatch(entitiesActions.upsertEvents(res.items));
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось загрузить события';
      throw error;
    }
  },
);
